/**
 * Maps ABP culture names to the Angular locale data files that ship with
 * `@angular/common`.
 *
 * `registerLocale` merges this over ABP's own `differentLocales` table, and
 * the result is looked up in the static loader map in `@abp/ng.core/locale`.
 * Every value below must be a key of that loader map, otherwise the locale
 * fails to load at runtime and the error handler swallows it.
 *
 * ABP's table already resolves each culture configured in
 * `AdministrationServiceDomainModule`, so these entries are a safety net: they
 * pin the region-specific cultures this app serves against upstream changes to
 * `differentLocales`, and add regional Arabic, which ABP does not map.
 */
export const cultureNameLocaleFileMap: Record<string, string> = {
  'de-DE': 'de',
  'pt-BR': 'pt',
  'ar-AE': 'ar',
};
